var notifications = "https://shopfront-cdn.tekoapis.com/static/96f7d19e0c6e8841.svg";

export { notifications as default };
